import Container from '@/components/base/Container';
import Section from '@/components/base/Section';
import SectionHeading from '@/components/base/SectionHeading';
import PageIntro from '@/components/base/PageIntro';
import CommunityCard from '@/components/base/CommunityCard';
import SplitSection from '@/components/base/SplitSection';
import SharedSpacesFeature from './components/SharedSpacesFeature';
import CommunitiesClosing from './components/CommunitiesClosing';
import { communityTypes, splitImages } from '@/mocks/site';

export default function Communities() {
  return (
    <>
      <PageIntro
        eyebrow="Communities"
        title="Different communities, the same standard of care."
        lead="Condominiums, apartment communities and planned neighborhoods share common ground, but each has its own decision-makers, responsibilities and resident expectations."
      />

      <Section labelledBy="types-heading" divider>
        <Container>
          <SectionHeading
            id="types-heading"
            eyebrow="Community types"
            title="Who we work with."
          />
          <div className="grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-3">
            {communityTypes.map((c) => (
              <CommunityCard key={c.id} title={c.title} summary={c.summary} image={c.image} focus={c.focus} />
            ))}
          </div>
        </Container>
      </Section>

      <SplitSection
        id="tailored-heading"
        divider
        eyebrow="Tailored management"
        title="We adapt the plan to how your community is governed."
        paragraphs={[
          'A condominium board votes on shared building decisions. An apartment owner sets service standards for residents who rent. A homeowners association may oversee streets, entries and amenities across many separate homes.',
          'Before proposing a scope, we learn who makes decisions, how residents prefer to hear from management and which parts of the property need the most attention.',
        ]}
        points={['Reporting cadence matched to your board or owner', 'Communication suited to owners, renters or homeowners', 'Maintenance priorities based on the property itself']}
        image={splitImages.tailored}
        imageAlt="Property manager reviewing a community site plan with residents"
      />

      <SharedSpacesFeature />

      <CommunitiesClosing />
    </>
  );
}